import { inject } from '@angular/core';
import { ResolveData } from '@angular/router';

import { MetaService } from '../services/meta.service';
import { IMetaData } from '../types/meta';

export function resolveMeta(meta: IMetaData): ResolveData {
  const { methodName }: IMetaData = meta;

  return {
    [methodName]: (): void => {
      const metaService: MetaService = inject(MetaService);

      metaService.updateMetaTags(meta);
    },
  };
}

export function range(start: number, end: number, step: number = 1): number[] {
  const result = [];
  for (let i = start; i <= end; i += step) {
    result.push(i);
  }

  return result;
}
